import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=bf410d62&"
import script from "./AuthForm.vue?vue&type=script&lang=js&"
export * from "./AuthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf410d62')) {
      api.createRecord('bf410d62', component.options)
    } else {
      api.reload('bf410d62', component.options)
    }
    module.hot.accept("./AuthForm.vue?vue&type=template&id=bf410d62&", function () {
      api.rerender('bf410d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/auth/AuthForm.vue"
export default component.exports